
/* injects from baggage-loader */

/*global NODE_ENV*/
'use strict';
import moment from 'moment';

/**
 * Application Main config.
 *
 * @param {any} $logProvider
 * @param {any} $compileProvider
 * @param {any} $authProvider
 */
function config($mdThemingProvider, $httpProvider, $logProvider, $compileProvider, $authProvider, $mdDateLocaleProvider, utilitiesConstant) {
	'ngInject';

	/*
	 * themes are still defined in config, but the css is not generated
	 */
	const theme = $mdThemingProvider.theme('default');
	theme.primaryPalette('teal', {
		'default': '500'
	})

	/*
	 * If you specify less than all of the keys, it will inherit from the default shades
	 */
	theme.accentPalette('amber', {
		'default': '500'
	});

	/**
	 * Date formatter.
	 */
	$mdDateLocaleProvider.formatDate = date => date ? moment(date).format('YYYY-MM-DD') : null;


	/**
	 * Log definition.
	 */
	if (NODE_ENV !== 'development') {
		$logProvider.debugEnabled(false);
		$compileProvider.debugInfoEnabled(false);
	} else {
		$logProvider.debugEnabled(true);
	}

	/**
	 * Satellizer configuration for management the auth token and the authenticated user
	 */
	$authProvider.storageType = utilitiesConstant.STORAGE.TYPE;
	$authProvider.tokenName = utilitiesConstant.STORAGE.TOKEN.NAME;
	$authProvider.tokenPrefix = utilitiesConstant.STORAGE.TOKEN.PREFIX;
	$authProvider.tokenHeader = utilitiesConstant.STORAGE.TOKEN.HEADER;
	$authProvider.tokenType = utilitiesConstant.STORAGE.TOKEN.TYPE;

	/**
	 * Http interceptor (factory file) when a REST services is consumed.
	 */
	$httpProvider.interceptors.push('httpInterceptor');

	/**
	 *  Locale config.
	 */
	moment.locale('es');
}

export default config;



// WEBPACK FOOTER //
// ./src/app/index.config.js